module.exports = __webpack_public_path__ + "static/media/Giorno.11a1d64a.png";